<template>

    <v-container fill-height>
        <v-row justify="center" align="center">
            <v-col cols="12" sm="12" class="text-center">
    
                <div v-if="loading">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <p class="mt-5">
                        Please wait while we are processing..
                    </p>
                </div>
                <div v-else>
    
                <v-col v-if="token">Please copy the below code (token) and  add  to your payment processor setting.</v-col>
                <v-alert
                prominent
                type="success"
                class="mt-3"
                v-if="token"
                >
                  <v-row align="center">
            
                    <v-col class="grow headline">{{ token }} </v-col>
                    <v-col class="shrink">
                      <v-btn color="primary" @click="copytext">COPY</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
    
                </div>
    
            </v-col>
        </v-row>
    </v-container>
    </template>
    
    
    <script>
    /* eslint-disable */
    import { mapGetters, mapMutations } from 'vuex'
    import { LocationAPI } from '@/clients/locations/locations.api'
    export default {
        data() {
          return {
            loading: true,
            token: ''
          }
        },
        async mounted() {
            // await this.vm_cloverDetails({
            //     clover_response: this.$route.query, //this.$route.query
            // })
            if(this.$route.query.code) {
                this.loading = true;
                await this.getCloverAccessToken(this.$route.query.code, 'Gr8table');
                this.loading = false;
            }
        },
        computed: {
            ...mapGetters({
                vg_selectedLocation: 'locations/selectedLocation',
                vg_cloverDetails: 'cloverGr8/details',
            }),
        },
    
    //    watch: {
    //         vg_cloverDetails: {
    //             handler: async function(cloverData) {
    //                 if(cloverData && cloverData.code){
    //                     this.loading = true;
    //                     await this.getCloverAccessToken(cloverData.code);
    //                     this.loading = false;
    //                 }
    //             },
    //             deep:true
    //         },
    //     },
    
    
      methods: {
       /**
         * 
         * get clover token
         */
        async getCloverAccessToken(accessKey, type) {
            try{
                let res = await LocationAPI.fetchCloverToken(accessKey, type);
                if(res.status == 200) {
                    this.token = res.data.payload.access_token;
                    await this.vm_cloverDetails({
                        clover_token: res.data.payload.access_token
                     })
                } else {
                    this.token = '';
                }
            } catch(err) {
                alert('Unable to proceed please try again later.')
                this.token = '';
            }
            
        },
    
        copytext() {
            navigator.clipboard.writeText(this.token);
            this.snackbar({ text: 'Copied!', color: 'success', icon: 'check' })
        },
        ...mapMutations({
            vm_cloverDetails: 'cloverGr8/detailsMutate'
        }),
      }
    }
    </script>
    
    <style>
    
    </style>